export const NAME = 'REQUEST_SPINNER';

export const START = `${NAME}/START`;
export const SUCCESS = `${NAME}/SUCCESS`;
export const FAIL = `${NAME}/FAIL`;
